import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getStaffList } from '@store/modules/staff_list';
import { getEnableOrganization } from '@store/modules/enable_org_tree';
import { queryExportHr } from '@api/hr/hr';
import ComponentOrg from './ComponentOrg';
import ComponentStaff from './ComponentStaff';
import './staff.less';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgUuid: undefined,
    };
  }

  componentWillMount() {
    this.current = 1;
    this.condition = '';
    this.orgUuid = '';
    this.status = 1;
  }

  componentDidMount() {
    this.props.dispatch(getEnableOrganization());
    this.getHr();
  }

  getHr = () => {
    const { dispatch } = this.props;
    dispatch(
      getStaffList({
        current: this.current,
        condition: this.condition,
        orgUuid: this.orgUuid,
        status: this.status,
      }),
    );
  };

  exportHr = () => {
    queryExportHr({ orgUuid: this.orgUuid || '' });
  };

  handleSearch = value => {
    this.condition = value;
    this.current = 1;
    this.getHr();
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getHr();
  };

  handleOrgChange = value => {
    this.orgUuid = value[0];
    this.setState({ orgUuid: value[0] });
    this.getHr();
  };

  ChangeStatus = value => {
    value === '2' ? (this.status = '') : (this.status = value);
    this.current = 1;
    this.getHr();
  };

  render() {
    return (
      <div style={{ display: 'flex' }} className="pageStaff">
        <div style={{ width: '300px', marginRight: '16px' }}>
          <ComponentOrg handleChange={this.handleOrgChange} />
        </div>
        <div style={{ flex: 1 }}>
          <ComponentStaff
            type="hr"
            getHr={this.getHr}
            exportHr={this.exportHr}
            orgUuid={this.state.orgUuid}
            handleSearch={this.handleSearch}
            ChangeStatus={this.ChangeStatus}
            handleTableChange={this.handleTableChange}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({ data: state.staff_list }))(Index);



// WEBPACK FOOTER //
// ./src/components/hr/staff/Index.js